/**
 * Created by Carsten Bühler
 * User: c.buehler on 09.06.2016
 * Copyright: xdot GmbH 2015
 */
'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';
import { Col, Row } from 'external/react-bootstrap';
import { translation, Title } from 'plugin/liferay-widgets-react-web';

const LogicLayerDetails = ({ item }) => {
    item = item && (item.item || item);

    return (
        <React.Fragment>
            {item &&
            <Title title={item.title}/>
            }
            <Row className="border-box">
                <Col lg={12} md={12} sm={12} xs={12}>
                    <h4>{translation.trans('description')}:</h4>{' '}
                    {item.description}
                </Col>
            </Row>
        </React.Fragment>
    );
};

LogicLayerDetails.propTypes = {
    item: PropTypes.object.isRequired
};

export default LogicLayerDetails;



// WEBPACK FOOTER //
// ./js/components/LogicLayerDetails.jsx